<template>
  <div v-if="render" class="main-page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="dtls-page">
      <div class="dtls-hero">
        <img :src="view.product_image">
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <div class="hero-badge">Attraction</div>
          <div class="hero-title">{{ view.ProductName }}</div>
          <div class="hero-meta">
            <span v-if="view.Location">
              <i class="fas fa-map-marker-alt fa-fw"></i>
              {{ view.Location }}
            </span>
            <span v-if="view.Duration.trim()">
              <i class="far fa-clock fa-fw"></i>
              {{ view.Duration }}
            </span>
          </div>
        </div>
      </div>

      <div class="info-bar">
        <div class="info-card" v-if="view.Duration.trim()">
          <div class="info-icon">
            <i class="far fa-clock fa-fw"></i>
          </div>
          <div>
            <label>Duration</label>
            <p>{{ view.Duration }}</p>
          </div>
        </div>
        <div class="info-card" v-if="view.Product_available_date && view.Product_available_date.length">
          <div class="info-icon">
            <i class="far fa-calendar fa-fw"></i>
          </div>
          <div>
            <label>Booking Date</label>
            <p>{{ formatDate(view.Product_available_date[0]) }}</p>
          </div>
        </div>
        <div class="info-card">
          <div class="info-icon">
            <i class="fas fa-users fa-fw"></i>
          </div>
          <div>
            <label>Travelers</label>
            <p>Up to {{ view.MaxTravellerCount }}</p>
          </div>
        </div>
        <div class="info-card" v-if="view.VoucherOption_List">
          <div class="info-icon">
            <i class="far fa-file-alt fa-fw"></i>
          </div>
          <div>
            <label>Voucher Type</label>
            <p>{{ view.VoucherOption_List.type }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="dtls-two-col">
      <div class="dtls-two-main">
        <div class="section-box">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>About This Experience</label>
          </div>
          <div class="description-text" v-html="view.Description"></div>
        </div>

        <div class="section-box" v-if="view.Inclusions && view.Inclusions.length">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>What's Included</label>
          </div>
          <div class="description-text" v-for="inc in view.Inclusions">
            <i class="fas fa-check fa-fw"></i>
            {{ inc.description }}
          </div>
        </div>

        <div class="section-box" v-if="view.Exclusions && view.Exclusions.length">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>What's NOT Included</label>
          </div>
          <div class="description-text" v-for="inc in view.Exclusions">
            <i class="fas fa-times fa-fw"></i>
            {{ inc.description }}
          </div>
        </div>
      </div>

      <div class="dtls-two-side">
        <div class="price-section">
          <div class="price-label">Price</div>
          <div class="price-value">
            {{ currencySymbol[currency.code] }}
            {{ applyCurrency(view.Price, false) }} 
            <span>{{ currency.code }}</span>
          </div>
          <div class="price-note">per person</div>
          <button class="km-btn" @click="bookNow">Book Now</button>
        </div>

        <div class="side-card" v-if="view.Cancellation_available">
          <div class="side-label">
            <i class="far fa-check-circle fa-fw"></i>
            Cancellation Policy
          </div>
          <p>{{ view.Cancellation_Policy }}</p>
        </div>
      </div>

    </div>

    <traveller-modal :trData="view" ref="trvModal" />
  </div>
</template>

<script>
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'
import moment from 'moment-timezone'
import TravellerModal from './traveller-modal'

export default {
  components: { TravellerModal },
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol
    }
  },
  computed: {
    sightSeeing () { return this.$store.state.sightSeeing },
    view () { return this.sightSeeing.view },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    backToSearch () {
      this.$router.push('/search')
      this.$store.commit('sightSeeing/setData', {view: null})
    },
    back () {
      this.$router.push('/sight-seeing')
      this.$store.commit('sightSeeing/setData', {view: null})
    },
    timeFormat (x) {
      return moment(x, 'HH:mm').format('hh:mmA')
    },
    formatDate (x) {
      if (!x) return ''
      return moment(x, 'YYYY-MM-DD').format('MMMM DD, YYYY')
    },
    bookNow () {
      if (this.$refs.trvModal) this.$refs.trvModal.showModal()
      // this.$router.push('/sight-seeing/review')
    },
    price (data) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.TotalDisplayFare
      if (data.Currency !== 'USD' && this.currency.code !== data.Currency) {
        x = x / this.currency.list[data.Currency]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: data.Currency,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    }
  },
  mounted () {
    this.render = false
    if (!this.sightSeeing.view) {
      this.backToSearch()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.main-page-box{
  // background: #fafafa;
  // border: 1px solid #ddd;
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover{
    color: #ff9c09;
  }
}

.dtls-hero{
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  img{
    width: 100%;
    height: 420px;
    object-fit: cover;
    display: block;
  }
}
.hero-overlay{
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.85) 0%, rgba(26, 26, 46, 0.2) 50%, transparent 100%);
}
.hero-content{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px;
}
.hero-badge{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ECAE20;
  color: #1a1a2e;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 14px;
  border-radius: 30px;
  margin-bottom: 16px;

  &::before{
    content: '';
    width: 6px;
    height: 6px;
    background: #1a1a2e;
    border-radius: 50%;
  }
}
.hero-title{
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
  line-height: 1.2;
}
.hero-meta{
  display: flex;
  align-items: center;
  gap: 20px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  flex-wrap: wrap;
  letter-spacing: .4px;
}

.info-bar{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.info-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid #ffe19c;
  transition: transform 0.2s, box-shadow 0.2s;

  label{
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #8892a0;
    margin-bottom: 4px;
  }
  p{
    font-size: 15px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0!important;
  }
}
.info-icon{
  width: 44px;
  height: 44px;
  background: rgba(236, 174, 32, 0.12);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i{
    color: #ECAE20;
  }
}

.dtls-two-col{
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}
.section-box{
  background: #fff;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;


}
.sb-header{
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  label{
    font-size: 18px;
    font-weight: 700;
    color: #1a1a2e;
  }
}
.sb-icon{
  width: 36px;
  height: 36px;
  background: rgba(236, 174, 32, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  i{
    color: #ECAE20;
  }
}
.description-text{
  font-size: 15px;
  color: #4a4a6a;
  line-height: 1.8;

  .fa-check{
    color: #16c942;
  }
  .fa-times{
    color: #db3030;
    vertical-align: -1px;
  }
}
.dtls-two-side > *{
  margin-bottom: 24px;
}
.side-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  p {
    font-size: 14px;
    color: #4a4a6a;
    line-height: 1.7;
    margin: 0;
  }
}
.side-label{
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  i{
    color: #22c55e;
  }
}

.price-section {
  background: #1a1a2e;
  border-radius: 10px;
  padding: 32px;
  color: #fff;
  position: relative;
  overflow: hidden;
}
.price-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}
.price-value {
  font-size: 42px;
  font-weight: 700;
  color: #ECAE20;
  margin-bottom: 4px;
  position: relative;
  z-index: 1;

  span {
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    margin-left: 4px;
  }
}
.price-note {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 24px;
  word-spacing: 2px;
  letter-spacing: .6px;
}
.km-btn {
  width: 100%;
  padding: 16px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  z-index: 1;
}


@media only screen and (max-width: 641px) {
}
</style>


// WEBPACK FOOTER //
// index.vue?6898032a